module.exports = __webpack_public_path__ + "img/img_productDisplay.14f64baa.png";